import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { updateUserData } from './utils/redux/actions';
import { useCheckSignIn, useRequestHook } from './utils/hooks/hooks';
import RenderRoutes from './components/RenderRoutes';
import Loading from './components/Loading';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/CSS/App.css';

const App = ({ dispatch, loading, checkStatus, userID, roles, services }) => {
	const noRoleService = [
		{
			id: 'error',
			serviceType: 'no_roles',
			name: 'No Roles',
			class: 'text-danger',
		},
	];

	const { handleRequest } = useRequestHook(); //Import request hook to handle all requests.

	const { checkUserStatus } = useCheckSignIn((data) =>
		dispatch(updateUserData(data))
	);

	const takeServices = (callback) => {
		if (Array.isArray(roles) && roles.length) {
			handleRequest('post', '/services/load-user-services', {}, (response) =>
				Array.isArray(response) && response.length
					? callback(response)
					: callback(noRoleService)
			);
		} else {
			callback(noRoleService);
		}
	};

	useEffect(() => {
		/**
		 * Check is user registered.
		 */
		if (checkStatus) checkUserStatus();
		if (userID && !services)
			takeServices((response) =>
				dispatch(updateUserData({ services: response }))
			);
	});

	return loading ? <Loading style={{ height: '100vh' }} /> : <RenderRoutes />;
};

/**
 * The function Map state to props receives two variables: state and ownProps.
 * 'state' is the global state or the stored data in redux.
 * 'ownProps' are all the props that are sended with the component.
 * It is necessary mapStateToProps allways to return an Object.
 * Even if we don't take nothing from the redux store, we need to return an empty Object,
 * so the state from redux store can be imported in the component.
 */
const mapStateToProps = ({ userData }) =>
	userData === undefined
		? { checkStatus: true, loading: true }
		: {
				loading: userData.id && !userData.services,
				userID: userData.id,
				roles: userData.roles,
				services: userData.services,
		  };

export default connect(mapStateToProps)(App); //Export component and connect it with redux.
